import * as React from 'react';
import { useCallback } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { compose, Dispatch } from 'redux';

import { cloneAlphaFromSimulate } from '../../actions/EditorActions/EditorActions';
import { DispatchConnect } from '../../types';
import { SIMULATE_LEARN } from '../../shared/constants';
import Learn from '../Learn/Learn';
import { useEditorRouterFilter } from '../../components/Editor/EditorRouterFiltersManager';

interface LearnProps {
  fullWidth: boolean;
  currentActiveTab: number;
  isMultiTab: boolean;
  currentChildActiveTab: number;
  cloneAlphaSimulate: boolean;
  checkIfTabIsEmptyCode: (tabIndex: number, tabIndexChild?: number | undefined) => boolean;
}

interface LearnStateDispatchers {
  dispatchChangeTabCode: (newValue: any, currentTabIndex: number, childActiveTab: number) => void;
}

type LearnSimulateGeneric = LearnProps & LearnStateDispatchers & RouteComponentProps<{}>;

const SIMULATE_LEARN_PATH = SIMULATE_LEARN.slice(1);

const LearnSimulate = ({
  fullWidth,
  currentActiveTab,
  isMultiTab,
  currentChildActiveTab,
  dispatchChangeTabCode,
  checkIfTabIsEmptyCode,
  ...routeComponentProps
}: LearnSimulateGeneric) => {
  const handleSimulateClone = useCallback(
    (alpha: any) => {
      const childActiveTab = isMultiTab ? currentChildActiveTab : -1;
      dispatchChangeTabCode(alpha.toJS(), currentActiveTab, childActiveTab);
    },
    [currentActiveTab, currentChildActiveTab, dispatchChangeTabCode, isMultiTab]
  );

  const handleShowModal = useCallback(() => {
    const childActiveTab = isMultiTab ? currentChildActiveTab : -1;
    let showModal = false;

    if (childActiveTab !== -1) {
      showModal = !checkIfTabIsEmptyCode(currentActiveTab, childActiveTab);
    } else {
      showModal = !checkIfTabIsEmptyCode(currentActiveTab);
    }

    return showModal;
  }, [checkIfTabIsEmptyCode, currentActiveTab, currentChildActiveTab, isMultiTab]);

  useEditorRouterFilter('learn');

  // @types/react@19 collapses the withRouter+connect wrapper's own props to `never`,
  // so Learn's own props (scope, path, etc.) are rejected. Cast to a permissive type;
  // runtime behavior is unchanged.
  const LearnComponent = Learn as React.ComponentType<any>;

  return (
    <div className={`learn-simulate ${fullWidth ? 'learn-simulate--full-width' : ''}`}>
      <LearnComponent
        scope="simulate"
        path={SIMULATE_LEARN_PATH}
        fullPlaylist={true}
        navHasText={false}
        hasHero={false}
        homeLink={true}
        hasTitle={true}
        scrollElement=".learn-simulate .learn__container"
        handleSimulateClone={handleSimulateClone}
        handleShowModal={handleShowModal}
        {...routeComponentProps}
      />
    </div>
  );
};

const mapDispatchToProps = (dispatch: Dispatch<any>): LearnStateDispatchers => ({
  dispatchChangeTabCode: (newValue: any, currentTabIndex: number, childActiveTab: number) => {
    dispatch(cloneAlphaFromSimulate(newValue, currentTabIndex, childActiveTab));
  },
});

export default compose<any>(withRouter, connect<{}, DispatchConnect<LearnStateDispatchers>>(null, mapDispatchToProps))(LearnSimulate);
